import { Navigation } from '../entities';
import { InjectionToken } from '@angular/core';

export interface DashboardItemsConfigurationToken {
  navigations: Navigation[];
}

export const DASHBOARD_ITEMS_CONFIGURATION_TOKEN = new InjectionToken<
  DashboardItemsConfigurationToken
>('Configure Navigation Items Configuration Token');
